import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke384aRequest, Sgke384aResponse, Sgke384aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke384aService {

  /**
   * コンストラクタ
   * @param {Sgke384aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke384aService
   */
  constructor(
    public service: Sgke384aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKE384A_サービサー委託対象移転先調査要否登録API呼出し
   * @param {Sgke384aRequest} request 
   * @returns {*}  {Observable<Sgke384aResponse>}
   * @memberof UsedSgke384aService
   */
  public doSgke384a(request: Sgke384aRequest): Observable<Sgke384aResponse> {

    return this.service.sgke384aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),

        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE384A');
          return throwError(err.message);
        })
      );
  }

}
